'use client';

import { useEffect } from 'react';
import { useNavigationDisplay } from '../context/navigationDisplay/NavigationDisplayContext';

type SimplifiedNavigationOptions = {
  hideSignUpButton?: boolean;
};

/**
 * Declares that the site header's mega menu (and optionally the sign-up button) should be hidden
 * while the calling component is mounted and `enabled` is true, restoring it on unmount/disable.
 */
export const useSimplifiedNavigation = (
  enabled = true,
  { hideSignUpButton = false }: SimplifiedNavigationOptions = {},
) => {
  const { registerOverride } = useNavigationDisplay();

  useEffect(() => {
    if (!enabled) return undefined;

    const unregisterMenu = registerOverride('hideMegaMenu');
    const unregisterSignUp = hideSignUpButton ? registerOverride('hideSignUpButton') : undefined;

    return () => {
      unregisterMenu();
      unregisterSignUp?.();
    };
  }, [enabled, hideSignUpButton, registerOverride]);
};
